import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'

/** 教师端 API（与管理端共用 JWT，base 为 /api/teacher） */
const teacherRequest = axios.create({
  baseURL: '/api/teacher',
  timeout: 15000
})

teacherRequest.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
})

teacherRequest.interceptors.response.use(
  response => {
    // blob 下载（如 Excel 模版）直接返回原始数据
    if (response.config.responseType === 'blob') {
      return response.data
    }
    const res = response.data
    if (res.code === 0) {
      return res.data
    }
    Message.error(res.message || '请求失败')
    return Promise.reject(new Error(res.message || '请求失败'))
  },
  error => {
    if (error.response) {
      const status = error.response.status
      if (status === 401) {
        Message.warning('登录已过期，请重新登录')
        localStorage.removeItem('admin_token')
        localStorage.removeItem('admin_info')
        router.push('/login')
      } else if (status === 403) {
        Message.error('无权限访问')
      } else {
        Message.error((error.response.data && error.response.data.message) || '服务器错误')
      }
    } else {
      Message.error('网络连接失败')
    }
    return Promise.reject(error)
  }
)

export default teacherRequest
